import { render, staticRenderFns } from "./Growers.vue?vue&type=template&id=023f0ed2&scoped=true&"
import script from "./Growers.vue?vue&type=script&lang=js&"
export * from "./Growers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f0ed2",
  null
  
)

export default component.exports